import iySP from './iy-sp';
import flourish from './flourish';
import demo from './demo';

const studios = {
  'iy-sp': iySP,
  'flourish': flourish,
  'demo': demo,
};

export default studios;
